import {Component, Input, Output, OnInit, ViewChild, ElementRef, HostListener, EventEmitter} from '@angular/core';



@Component({
    selector: 'pad-component',
    templateUrl: './pad.component.html',
    styleUrls: ['./pad.component.scss']
})
export class PadComponent implements OnInit {
    
    @Input() value: number = null;
    @Output() valueChange = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        // setTimeout(_ => /*code*/ );
    }

    ngOnChanges(){
        console.log('changes');
    }

    sendValue(){
        let value = this.value;
        this.valueChange.emit(value);
        this.value = null;
    }


}



// WEBPACK FOOTER //
// ./src/app/components/pad/pad.component.ts